/* eslint-disable new-cap */
import * as t from 'runtypes';

export const UIMode = t
  .Union(t.Literal('iframe'), t.Literal('document'), t.Literal('drawer'))
  .Or(t.Undefined);

export type UIMode = t.Static<typeof UIMode>;
